import { useState, useEffect } from 'react';

interface UseDebouncedValueProps {
  value: string | null;
  delay: number;
}

export default function useDebouncedValue({
  value,
  delay,
}: UseDebouncedValueProps): string | null {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (value === null) return;

    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

//  USAGE
//  const [searchTerm, setSearchTerm] = useState('');
//  const debouncedSearchTerm = useDebounce(searchTerm, 500);
//  useEffect(() => {
//     // This will only run 500ms after the user stops typing
//     performSearch(debouncedSearchTerm);
//   }, [debouncedSearchTerm]);
